module.exports = __webpack_public_path__ + "assets/img/office-marker.9eabc253.svg";